'use client'

import { DEFAULT_LANGUAGE, generateJobListHtml, Language } from '@dvinci/attract-studio-components'
import { FC, useEffect, useRef } from 'react'

export type JobsTemplateScriptProps = {
  jobWidgetId: string | null
  language?: Language
}

export const JobsTemplateScript: FC<JobsTemplateScriptProps> = ({ jobWidgetId, language = DEFAULT_LANGUAGE }) => {
  const loaderRef = useRef<{ src: string; script: HTMLScriptElement } | null>(null)

  const extractScriptSrc = (htmlString: string): string | null => {
    if (typeof window === 'undefined') return null // Prevent running in SSR
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlString, 'text/html')
    const scriptTag = doc.querySelector('script')
    return scriptTag ? scriptTag.getAttribute('src') : null
  }

  useEffect(() => {
    if (typeof window === 'undefined') return // Prevent running in SSR
    const jobWidgetHtml = generateJobListHtml(jobWidgetId, language)
    const scriptSrc = extractScriptSrc(jobWidgetHtml)

    if (!scriptSrc || loaderRef.current?.src === scriptSrc) return

    loaderRef.current?.script.remove()

    const script = document.createElement('script')
    const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')
    script.src = scriptSrc
    script.async = true
    if (nonce) script.nonce = nonce
    document.body.appendChild(script)

    loaderRef.current = { src: scriptSrc, script }
  }, [jobWidgetId, language])

  return <div key={`${jobWidgetId}-${language}`} className="dvinci-job-widget" />
}

export default JobsTemplateScript
